import * as React from 'react';
import { Space } from 'antd';
import MetricsPopup from './MetricsPopup';
import Toolbar from './Toolbar';
import { PanelWrapper, StyledGranularitySelect, StyledSpinner } from './styled';
import StateTags from './StateTags';
import UnitToggle from '@components/common/UnitToggle';
import Resize from './Resize';
import { FlexFill } from '@components/common/Utils/Layout';
import { useAtom } from 'jotai';
import { sizeAtom, unitAtom } from '../atoms';
import DebugAtoms from '../atoms/Debug';
import { tid } from '@utils/test';
import { track } from '@utils';
import { CHANGE_CHART_SIZE, CHANGE_CHART_UNIT } from '@src/utils/sensor/track';
import CompareWarning from './CompareWarning';
import { useDispatch, useSelector } from 'react-redux';
import { updateGranularity } from '@store/common/actions';
import { intervalSelector } from '@store/common/selectors';
import ExportChart from './ExportChart';

function ControlPanel({ activeTool, setActiveTool, panelLoading }) {
  const dispatch = useDispatch();
  const [unit, setUnit] = useAtom(unitAtom);
  const [size, setSize] = useAtom(sizeAtom);
  const interval = useSelector(intervalSelector);

  const handleUnitChange = (value) => {
    track({
      event: CHANGE_CHART_UNIT,
      data: { unit: value },
    });
    setUnit(value);
  };

  const handleSizeChange = (value) => {
    track({
      event: CHANGE_CHART_SIZE,
      data: { size: value },
    });
    setSize(value);
  };

  const handleGranularityChange = (value) => {
    dispatch(updateGranularity(value));
  };

  return (
    <PanelWrapper {...tid('controls')}>
      <DebugAtoms />
      <StyledSpinner size="small" spinning={panelLoading} {...tid('bg-loader')} />
      <StateTags />
      <FlexFill />
      <Space>
        <CompareWarning />
        <StyledGranularitySelect updateGranularity={handleGranularityChange} interval={interval} />
        <Resize value={size} onChange={handleSizeChange} />
        <Toolbar activeTool={activeTool} setActiveTool={setActiveTool} />
        <ExportChart />
        <MetricsPopup />
        <UnitToggle selectedUnit={unit} onChange={handleUnitChange} />
      </Space>
    </PanelWrapper>
  );
}

export default ControlPanel;
